import type { ImportFileFormat } from '../types/stockImports.types'

export const IMPORT_FILE_EXTENSIONS: Record<ImportFileFormat, string[]> = {
  EXCEL: ['xlsx', 'xlsm', 'xls'],
  CSV: ['csv', 'tsv'],
  XML: ['xml'],
}

export const IMPORT_FILE_FORMAT_LABELS: Record<ImportFileFormat, string> = {
  EXCEL: 'Excel',
  CSV: 'CSV',
  XML: 'XML',
}

export const formatImportFileExtensions = (fileFormat: ImportFileFormat) =>
  IMPORT_FILE_EXTENSIONS[fileFormat]
    .map((extension) => `.${extension}`)
    .join(', ')

export const getImportFileFormatByExtension = (
  extension?: string | null
): ImportFileFormat | null => {
  const normalizedExtension = extension?.trim().replace(/^\./, '').toLowerCase()
  if (!normalizedExtension) return null

  const entry = (
    Object.entries(IMPORT_FILE_EXTENSIONS) as Array<
      [ImportFileFormat, string[]]
    >
  ).find(([, extensions]) => extensions.includes(normalizedExtension))

  return entry?.[0] ?? null
}
